import type {FC} from 'react';
import React from 'react';

export const withAuthGuard =
    <P extends object>(Component: FC<P>): FC<P> =>
    // eslint-disable-next-line react/display-name
    (props: P) =>
        <Component {...props} />;
